import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { RelatedDocument } from '../related-doc/related-doc.model';

@Component({
  selector: 'related-docs',
  templateUrl: './related-docs.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./related-docs.component.css'],
})
export class RelatedDocsComponent implements OnInit {
  @Input() relatedDocuments: RelatedDocument[];
  @Input() docType: string;

  constructor() {}

  isCompetition(docType: string) {
    if (docType === 'COMPETITION_LAW_DOC' || docType === 'STATE_AID' || docType === 'DMA_CASE') {
      return 'Similar and related cases';
    } else {
      return 'Reference Documents';
    }
  }

  ngOnInit(): void {}
}
